/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'empty',
    standalone: true,
})
export class EmptyPipe implements PipeTransform {
	transform(input: any): any {
		if (input === '' || input === undefined || input === null) {
			return '-';
		}
		return input;
	}
}
